import moment from "moment";
import { useContext, useEffect, useState } from "react";
import ExportIcon from "../../Assets/Icons/outline/export-3.svg";
import CalendarIcon from "../../Assets/Icons/outline/calendar-1.svg";
import ArrowDownIcon from "../../Assets/Icons/outline/arrow-circle-down.svg";
import CloseIcon from "../../Assets/Icons/outline/close-circle-white.svg";
import AdminContext from "../../Services/Admin";
import Button from "../../Components/Button";
import { toast } from "react-toastify";
import CalendarPicker from "../../Components/CalendarPicker/CalendarPicker";
import ContributorPicker from "../../Components/ContributorPicker/ContributorPicker";
import Input from "../../Components/Input";
import ApiWithAuth from "../../Config/Api/ApiWithAuth";

const ActionPage = ({
  setCurrentMonth,
  setShowMonth,
  showMonth,
  currentMonth,
  monthArray,
  fullPage,
  setFullPage,
  selectedMember,
  setSelectedMember,
}) => {
  const { loading, getAllMaster } = useContext(AdminContext);
  const [showMember, setShowMember] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [dataMember, setDataMember] = useState([]);
  const [datePicker, setDatePicker] = useState({ start: null, end: null });
  const [contributorPicker, setContributorPicker] = useState([]);

  useEffect(() => {
    if (showMember) {
      getDataMember();
    }
  }, [showMember]);

  const getDataMember = async () => {
    const newData = await getAllMaster(`master/member`);
    if (newData) {
      setDataMember(newData?.data);
    }
  };

  const exportExcel = async () => {
    if (datePicker?.start && datePicker?.end) {
      const contributor = contributorPicker?.map((item) => item?.id);
      const newData = await ApiWithAuth.downloadDataWithAuth(
        `project/export`,
        {
          start: moment(datePicker?.start).format("YYYY-MM-DD"),
          end: moment(datePicker?.end).format("YYYY-MM-DD"),
          m_users_id: contributor,
        },
        `Export ${moment(datePicker?.start).format("DD-MM-YYYY")} _ ${moment(
          datePicker?.end
        ).format("DD-MM-YYYY")}`,
        "xlsx"
      );
    } else {
      toast.success("Select start date and end date first!");
    }
  };

  const onChange = (evt, item) => {
    if (evt) {
      setSelectedMembers([...selectedMembers, item]);
    } else {
      setSelectedMembers(selectedMembers.filter((a) => a.id !== item.id));
    }
  };

  useEffect(() => {
    if (selectedMembers) {
      let newMember = "";
      selectedMembers?.map((item) => {
        newMember += "member[]=" + item.id + "&";
      });
      setSelectedMember(newMember.slice(0, -1));
    } else {
      setSelectedMember(null);
    }
  }, [selectedMembers]);

  return (
    <div className="flex items-center">
      <div className=" relative">
        <button
          type="button"
          onClick={() => setShowExport((prev) => (prev ? false : true))}
          className="p-2 bg-black rounded-lg shadow-[0px_0px_4px_3px_#00000040] me-3"
        >
          <img src={ExportIcon} alt="" className="w-[25px] h-[25px]" />
        </button>
        {showExport && (
          <div
            style={{ zIndex: 60 }}
            className="absolute top-[50px] right-0 border w-[400px] h-[750px] overflow-y-scroll bg-white rounded-xl shadow-[0px_0px_4px_0px_#00000040] p-4"
          >
            <CalendarPicker
              datePicker={datePicker}
              setDatePicker={setDatePicker}
              show
            />
            <ContributorPicker
              contributorPicker={contributorPicker}
              setContributorPicker={setContributorPicker}
            />
            <Button className="pt-3 pb-2 text-sm" onClick={() => exportExcel()}>
              Export
            </Button>
          </div>
        )}
      </div>
      <div
        className="flex items-center rounded-full shadow-[0px_0px_4px_3px_#00000040] py-2 px-5 relative me-5"
        role="button"
        onClick={() => setShowMember((prev) => (prev ? false : true))}
      >
        <div className="pt-1 me-3 font-semibold text-sm">Onboard</div>
        <div className="flex items-center justify-end w-[100px]">
          <div
            className={`absolute right-[68px] bg-white w-[30px] h-[30px] rounded-full border border-black p-1 ${
              selectedMembers?.length > 5 && "bg-[#00ff61]"
            }`}
          ></div>
          <div
            className={`absolute right-[56px] bg-white w-[30px] h-[30px] rounded-full border border-black p-1 ${
              selectedMembers?.length > 4 && "bg-[#00ff61]"
            }`}
          ></div>
          <div
            className={`absolute right-[44px] bg-white w-[30px] h-[30px] rounded-full border border-black p-1 ${
              selectedMembers?.length > 3 && "bg-[#00ff61]"
            }`}
          ></div>
          <div
            className={`absolute right-[32px] bg-white w-[30px] h-[30px] rounded-full border border-black p-1 ${
              selectedMembers?.length > 2 && "bg-[#00ff61]"
            }`}
          ></div>
          <div
            className={`absolute right-[20px] bg-white w-[30px] h-[30px] rounded-full border border-black p-1 ${
              selectedMembers?.length > 1 && "bg-[#00ff61]"
            }`}
          ></div>
          <div
            className={`absolute right-[8px] bg-white w-[30px] h-[30px] rounded-full border border-black p-1 ${
              selectedMembers?.length > 0 && "bg-[#00ff61]"
            }`}
          ></div>
        </div>

        {showMember && (
          <div
            style={{ zIndex: 60 }}
            className="absolute top-[50px] left-0 border w-[250px] h-[250px] overflow-y-scroll bg-white rounded-xl shadow-[0px_0px_4px_0px_#00000040] p-4"
          >
            {dataMember &&
              dataMember?.map((item, index) => (
                <label
                  key={"member-" + index}
                  htmlFor={"member-" + index}
                  className="flex items-center justify-between mb-3"
                >
                  <input
                    id={"member-" + index}
                    type="checkbox"
                    className="w-5 h-5 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                    checked={selectedMembers
                      ?.map((item) => item?.id)
                      ?.includes(item?.id)}
                    onChange={(evt) => onChange(evt?.target?.checked, item)}
                  />
                  <div className="flex flex-col text-right">
                    <div className="font-semibold text-sm">{item?.name}</div>
                    <div className="text-xs">{item?.roles?.[0]?.name}</div>
                  </div>
                </label>
              ))}
          </div>
        )}
      </div>
      <div
        className="w-[250px] rounded-full shadow-[0px_0px_4px_3px_#00000040] py-2 px-5 relative"
        onClick={() => setShowMonth((prev) => (prev ? false : true))}
      >
        <div role="button" className="flex items-center justify-between ">
          <div className="me-2 font-semibold">
            <img src={CalendarIcon} alt="" />
          </div>
          <div className="pt-1 me-2 font-semibold text-sm">{currentMonth.format("MMMM YYYY")}</div>
          <div className="font-semibold">
            <img src={ArrowDownIcon} alt="" />
          </div>
        </div>
        {showMonth && (
          <div
            style={{ zIndex: 60 }}
            className="absolute top-[50px] left-0 border w-[250px] h-[250px] overflow-y-scroll bg-white rounded-xl shadow-[0px_0px_4px_0px_#00000040] p-4"
          >
            {monthArray?.map((item, index) => (
              <div
                key={index}
                role="button"
                onClick={() => {
                  setCurrentMonth(item);
                }}
                className={`flex items-center justify-between rounded-xl border-black px-3 py-1 mb-1 ${
                  item?.isSame(currentMonth) ? "border-4" : "border"
                }`}
              >
                <img src={CalendarIcon} alt="" />
                <div>{item?.format("MMMM YYYY")}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      {fullPage && (
        <button
          type="button"
          className="p-2 bg-black rounded-lg shadow-[0px_0px_4px_3px_#00000040] ms-5"
          onClick={() => setFullPage(false)}
        >
          <img src={CloseIcon} alt="" className="w-[25px] h-[25px]" />
        </button>
      )}
    </div>
  );
};

export default ActionPage;
